// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal--2R9ow","in":"in--1T3o2","inner":"inner--2d89w","close":"close--StKS7"};